export default __webpack_public_path__ + "static/media/selectedRakibImage.eec29258.png";